// bluaIQ — Detect legacy (pre-#233) bundled Classic schedule tasks
//
// Before PR #233, "Auto-Generate Classic" produced ONE comma-bundled scope row
// per construction subphase (e.g. "Siding, brick, paint, garage door"). The
// generator now emits individual actionable rows, but projects generated before
// #233 still hold the old bundled tasks in their DB. This pure, FE-only helper
// detects those stale rows so the Gantt can show a non-destructive "regenerate"
// prompt — it NEVER mutates, regenerates, or splits anything.
//
// Detection is by EXACT stored task string (the 14 original Classic bundle
// labels), so fresh split rows ("Wall framing", "Rough plumbing", …) are never
// flagged.

export const LEGACY_BUNDLED_CLASSIC_TASKS: ReadonlySet<string> = new Set([
  'Grading, utilities, temporary power',
  'Slab-on-grade / pier & beam',
  'Walls, roof trusses, sheathing',
  'Shingles, underlayment, flashing',
  'Plumbing, electrical, HVAC rough',
  'Walls R-13, attic R-38',
  'Hang, tape, float, texture',
  'Prime + 2 coats walls & ceilings',
  'LVP, tile, carpet install',
  'Kitchen, bath vanities, countertops',
  'Fixtures, outlets, switches, HVAC startup',
  'Siding, brick, paint, garage door',
  'Sod, irrigation, fencing, driveway',
  'City final, punch list, CO',
])

/** True if `task`'s stored name is a legacy bundled Classic label. */
export function isLegacyBundledTask(task: { name?: string | null }): boolean {
  return LEGACY_BUNDLED_CLASSIC_TASKS.has((task.name || '').trim())
}

/**
 * True if any task in the schedule is a legacy bundled Classic row. Read-only —
 * does not modify, regenerate, or split anything.
 */
export function hasLegacyBundledTasks(tasks: ReadonlyArray<{ name?: string | null }>): boolean {
  return tasks.some(isLegacyBundledTask)
}
